import { render, staticRenderFns } from "./CarouselFramedSlideText.vue?vue&type=template&id=5713643c&"
import script from "./CarouselFramedSlideText.vue?vue&type=script&lang=js&"
export * from "./CarouselFramedSlideText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports